import { render } from "./menuStartFavorites.vue?vue&type=template&id=49663adb&scoped=true"
import script from "./menuStartFavorites.vue?vue&type=script&lang=js"
export * from "./menuStartFavorites.vue?vue&type=script&lang=js"

import "./menuStartFavorites.vue?vue&type=style&index=0&id=49663adb&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-49663adb"

export default script